export const INBOX_UPDATE_INTERVAL = 10000;
export const AgentInboxPollId = 'agent-inbox-poll';
